// extracted by mini-css-extract-plugin
module.exports =  {"icon-wrapper":"_93444fe79c--icon-wrapper--OWnQu"};